export default __webpack_public_path__ + "static/media/preloader.81eb21a6.gif";